<template>
  <div>
    <div class="row ml-1">
      <v-tabs
        v-model="tabGroups"
        color="white"
        show-arrows
      >
        <v-tabs-slider color="white" />

        <v-tab
          v-for="(group, groupIndex) in WageSupplementConfigurations"
          :key="groupIndex"
          class="tablinks"
        >
          {{ group.wageSupplementConfigurationTitle }}
        </v-tab>
      </v-tabs>
      <CreateZuschlagsConfiguration
        :can-user-edit="canUserEdit"
        :languages="
          $store.state.mindestLohnKonfiguration.BasicContractInformation
            .translatedLanguages
        "
        class="mt-2 ml-4"
        @created="LoadExistringWageSupplementConfigurations"
      />
    </div>
    <!-- Content -->
    <v-tabs-items
      id="custom-tab-items"
      v-model="tabGroups"
    >
      <v-tab-item
        v-for="(group, groupIndex) in WageSupplementConfigurations"
        :key="groupIndex"
      >
        <v-card class="pt-2">
          <!-- Navigation -->
          <div class="row ml-2 w-100">
            <v-tabs
              v-model="tab"
              color--text="grey"
              grow
            >
              <v-tabs-slider color="#e72b37" />
              <!-- Die Navigationsdaten kommen aus den headerItems -->
              <v-tab
                v-for="(headerItem, headerItemIndex) in headerItems"
                :key="headerItemIndex"
                :disabled="
                  !(
                    headerItem === 'Arbeitszeit erfassung' ||
                    headerItem === 'Überstundenregelung erfassung' ||
                    headerItem === 'Zugschlagsdefinitionen erfassung'
                  )
                "
                class="tablinksInner"
              >
                {{ headerItem }}
              </v-tab>
            </v-tabs>
            <EditZuschlagsConfiguration
              :can-user-edit="canUserEdit"
              :languages="
                $store.state.mindestLohnKonfiguration.BasicContractInformation
                  .translatedLanguages
              "
              :zuschlags-configuration="group"
              class="mt-2 ml-4"
              @updated="LoadExistringWageSupplementConfigurations"
            />
            <button
              v-if="groupIndex === tabGroups && canUserEdit"
              v-b-tooltip.hover
              class="btn btn-danger mt-2 ml-1 smallActionButton"
              placement="bottom"
              title="Gruppierung löschen"
              type="button"
              @click="
                showModal('deleteWageSupplementConfiguration');
                wageSupplementConfigurationToDelete = group;
              "
            >
              <i class="fas fa-trash-alt" />
            </button>
          </div>
          <!-- Content -->
          <v-tabs-items
            id="custom-tab-items"
            v-model="tab"
          >
            <v-tab-item
              v-for="(headerItem, headerItemIndex) in headerItems"
              :key="headerItemIndex"
            >
              <!-- Component zur Arbeitszeit erfassung wird aufgrufen -->
              <worktime
                v-if="headerItem === 'Arbeitszeit erfassung'"
                :wage-supplement-configuration-id="group.id"
              />
              <overtime
                v-if="headerItem === 'Überstundenregelung erfassung'"
                :wage-supplement-configuration="group"
              />
              <definition
                v-if="headerItem === 'Zugschlagsdefinitionen erfassung'"
                :wage-supplement-configuration-id="group.id"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <b-modal
      id="deleteWageSupplementConfiguration"
      ref="deleteWageSupplementConfiguration"
      class="w-100"
      hide-footer
      no-fade
      scrollable
      size="lg"
      title="Zuschlagsgruppierung löschen"
    >
      <div class="d-block mb-4">
        Sind Sie sicher, dass Sie diese Zuschlagsgruppierung löschen möchten
      </div>
      <b-button
        variant="success"
        @click="DeleteSelectedWageSupplementConfiguration"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        @click="hideModal('deleteWageSupplementConfiguration')"
      >
        Abbrechen
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import Worktime from "./Capture/Worktime.vue";
import Overtime from "./Capture/Overtime.vue";
import Definition from "./Capture/Definition.vue";
import CreateZuschlagsConfiguration from "./CreateZuschlagsConfiguration.vue";
import EditZuschlagsConfiguration from "./EditZuschlagsConfiguration.vue";
import {
  GetWageSupplementConfigurations,
  DeleteWageSupplementConfiguration,
} from "@/services/minimum.wage.services/zuschlagsrechner/supplementconfigurations";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  components: {
    Worktime,
    Overtime,
    Definition,
    CreateZuschlagsConfiguration,
    EditZuschlagsConfiguration,
  },
  mixins: [MinimumWageMixin],
  data() {
    return {
      tab: null, //Um das Ausgewählte Tab zu hinterlegen
      tabGroups: null, //Um das Ausgewählte Tab zu hinterlegen
      headerItems: [
        "Arbeitszeit erfassung",
        "Überstundenregelung erfassung",
        "Zugschlagsdefinitionen erfassung",
      ], //Werden die Navigationsdaten definiert
      WageSupplementConfigurations: [],
      wageSupplementConfigurationToDelete: null,
    };
  },
  watch: {
    tabGroups() {
      this.tab = 0;
    },
  },
  created() {
    if (
      !this.$store.state.mindestLohnKonfiguration.Criteria ||
      this.$store.state.mindestLohnKonfiguration.Criteria.length === 0
    ) {
      this.$store.dispatch("getCriteria", {
        contractId: this.contractId,
        versionId: this.versionId,
        editionId: this.editionId,
      });
    }
    this.LoadExistringWageSupplementConfigurations();
  },
  methods: {
    LoadExistringWageSupplementConfigurations() {
      GetWageSupplementConfigurations(
        this.contractId,
        this.versionId,
        this.editionId,
        this.editionId,
        (response) => {
          if (response && response.length > 0) {
            this.WageSupplementConfigurations = response;
          }
          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.isLoading = false;
        },
      );
    },
    DeleteSelectedWageSupplementConfiguration() {
      DeleteWageSupplementConfiguration(
        this.contractId,
        this.versionId,
        this.editionId,
        this.editionId,
        this.wageSupplementConfigurationToDelete.id,
        () => {
          this.hideModal("deleteWageSupplementConfiguration");
          this.wageSupplementConfigurationToDelete = null;
          this.LoadExistringWageSupplementConfigurations();
          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.isLoading = false;
        },
      );
    },
    showModal(modalId) {
      this.$refs[modalId].show();
    },
    hideModal(modalRef) {
      if (this.$refs[modalRef]) {
        this.$refs[modalRef].hide();
      }
    },
  },
};
</script>

<style>
.tablinks a {
  border-top: 2px solid transparent;
  text-decoration: none !important;
  background-color: lightgrey;
  transition: width 0.5s ease-in-out;
}

.tablinks a:hover {
  color: #e72b37 !important;
  opacity: 1;
}

.tablinks .v-tabs__item.v-tabs__item--active {
  background-color: white !important;
  color: #e72b37;
  border-left: 1px solid lightgrey;
  border-right: 1px solid white;
  border-top: 2px solid #e72b37;
  transition: all 0.5s ease-in-out;
  width: 100%;
}

.tablinksInner a {
  transition: width 0.5s ease-in-out;
}

.tablinksInner a:hover {
  color: #e72b37 !important;
  opacity: 1;
}

.tablinksInner .v-tabs__item.v-tabs__item--active {
  background-color: white !important;
  color: #e72b37;
  transition: all 0.5s ease-in-out;
  width: 100%;
}
</style>
